import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import DeleteConfirmationModal from "./delete-confirmation-modal";
import VideoPopover from "./video-popover";
import { toast } from "react-toastify";
import AddTranscriptModal from "./add-transcript-modal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const TranscriptTable = ({ videoCode, onPlayClick, videoProgress, scrollRef, enableChapterRegeneration, isAdmin, hasEdit }) => {
    // const [loading, setLoading] = useState(false);
    // const [data, setData] = useState([]);
    const [localData, setLocalData] = useState([]);

    const [editMode, setEditMode] = useState([]);
    const [showAddTranscript, setShowAddTranscript] = useState(false)

   const [saving, setSaving] = useState([])

    const [deleteItem, setDeleteItem] = useState(null);

    const [videoPopoverTranscriptData, setVideoPopoverTranscriptData] = useState(null);
    const [videoPopoverTarget, setVideoPopoverTarget] = useState(null);

    const queryClient =  useQueryClient();

    const fetchTranscript = useCallback(async () => {
        if (!videoCode) return [];
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/video_guide/transcripts?VideoID=${videoCode}`);
        if (response.data) {
            return response.data.data.transcription;
        }
    }, [videoCode]);

    // const fetchTranscript = async()=>{
    //     if(!videoCode) return [];
    //     const response = await axios.get(`${process.env.REACT_APP_API_URL}/video_guide/transcripts?VideoID=${videoCode}`)
    //     if(response.data){
    //         return response.data.data.transcription;
    //     }
    // }

    const {data: transcriptData=[], isLoading: isTranscriptLoading} = useQuery({
        queryFn: fetchTranscript,
        queryKey: ['fetchTranscript', videoCode],
        enabled: !!videoCode,
    })


    const refreshTranscript = useCallback(() => {
        queryClient.invalidateQueries(['fetchTranscript', videoCode]);
    }, [queryClient, videoCode]);

    // useEffect(() => {
    //     if (transcriptData) {
    //         setData(transcriptData)
    //     }

    // }, [transcriptData])

    // const loadData = useCallback(() => {
    //     setLoading(true)
    //     axios.get(`${process.env.REACT_APP_API_URL}/video_guide/transcripts?VideoID=${videoCode}`)
    //         .then((response) => {
    //             if (response.data) {
    //                 setData(response.data.data.transcription);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //         }).finally(() => {
    //             setLoading(false)
    //         })
    // }, [videoCode])

    // useEffect(() => {
    //     if (!videoCode) {
    //         setData([])
    //         return;
    //     }
    //     loadData()
    // }, [videoCode, loadData])

    useEffect(() => {
        if (!transcriptData) return;

        setLocalData(prev => {
            // prevent unnecessary updates
            if (JSON.stringify(prev) === JSON.stringify(transcriptData)) {
                return prev;
            }
            return transcriptData;
        });
    }, [transcriptData]);


    const saveTranscript = async ({val, i}) => {
        setSaving((prev) => [...prev, i])
        await axios.post(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
            VideoID: videoCode,
            data: val,
        })
    }       

    const {mutate: saveTranscriptMutation } = useMutation({
        mutationFn: saveTranscript,
        onSuccess: (_, variables) => {
            setEditMode((prev) => prev.filter(idx => idx !== variables.i))
            enableChapterRegeneration(true);
            toast.success("Successfully saved the transcript modification.");
        },
        onError: (err) => {
            // console.log(err)
            toast.error("Error saving the transcript modification.");
        },
        onSettled: (_, __, variables) => {
            setSaving((prev) => prev.filter(idx => idx !== variables.i))
        }
    })

 
    // const onSave = useCallback((val, i) => {
    //     setSaving((prev) => [...prev, i])
    //     axios.post(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
    //         VideoID: videoCode,
    //         data: val,
    //     })
    //         .then((response) => {
    //             setEditMode((prev) => prev.filter(idx => idx !== i))
    //             enableChapterRegeneration(true);
    //             toast.success("Successfully saved the transcript modification.");
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //             toast.error("Error saving the transcript modification.");
    //         }).finally(() => {
    //             setSaving((prev) => prev.filter(idx => idx !== i))
    //         })
    // }, [videoCode, enableChapterRegeneration])

    const deleteTranscript = async ({val}) => {
        await axios.delete(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
            data: { 
                VideoID: videoCode,
                data: val
            }
        })
    }


    const {mutate: deleteTranscriptMutation, isPending: isDeletingTranscript} = useMutation({
        mutationFn: deleteTranscript,
        onSuccess: () => {
            refreshTranscript();
            setDeleteItem(null);
            enableChapterRegeneration(true);
            toast.success("Successfully removed the transcript.");
        },
        onError: (err) => {
            console.log(err)
            toast.error("Error removing the transcript.");
        }
    })

    // const [deleteConfirmationIndex, setDeleteConfirmationIndex] = useState();
    // const [deleting, setDeleting] = useState(false)
    // const onDelete = useCallback((i) => {
    //     setDeleting(true)
    //     const val = data[i];
    //     axios.delete(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
    //         data: {
    //             VideoID: videoCode,
    //             data: val,
    //         }
    //     })
    //         .then((response) => {
    //             // setData(response.data.data.transcription)
    //             setDeleteConfirmationIndex()
    //             enableChapterRegeneration(true);
    //             refreshTranscript(); // ✅
    //             toast.success("Successfully removed the transcript.");
    //         })
    //         .catch((err) => {
    //             console.log(err)
    //             toast.error("Error removing the transcript.");
    //         }).finally(() => {
    //             setDeleting(false)
    //         })
    // }, [videoCode, data, enableChapterRegeneration])

    return (
        <>
        {(isAdmin || hasEdit) &&
            <div style={{ textAlign: "left" }}>
                <Button
                    variant="secondary"
                    size="sm"
                    style={{
                        minHeight: "32px",
                        padding: "6px 10px",
                    }}
                    onClick={() => {
                        setShowAddTranscript(true);
                    }}
                >
                    Add new transcript
                </Button>
            </div>
        }
            <VideoPopover
                targetRef={videoPopoverTarget}
                startTime={videoPopoverTranscriptData?.start}
                endTime={videoPopoverTranscriptData?.end}
                videoId={videoCode}
                onClose={() => {
                    setVideoPopoverTarget(null);
                    setVideoPopoverTranscriptData(null);
                }}
            />
            <div className="d-flex flex-column">
                <Table responsive className="mt-2 transcript-list-table">
                    <thead>
                        <tr>
                            <th>Start (sec)</th>
                            <th>End (sec)</th>
                            <th>Transcript</th>
                            <th>Play</th>
                            {(isAdmin || hasEdit) &&
                            <th>Edit</th>
                            }                            
                            {(isAdmin || hasEdit) &&    
                            <th>Delete</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {isTranscriptLoading &&
                            <tr className="text-center">
                                <td colSpan={100}>
                                    Loading...
                                </td>
                            </tr>
                        }
                        {!isTranscriptLoading && !localData?.length &&
                            <tr className="text-center">
                                <td colSpan={100}>
                                    No transcripts found
                                </td>
                            </tr>
                        }
                        {!isTranscriptLoading && localData && localData.map((val, i) => (
                            <tr key={i} style={{
                                background: videoProgress > val.start && videoProgress < val.end ? '#cfe2ff' : 'white'
                            }}>
                                <td>{Math.round(val.start * 100) / 100}</td>
                                <td>{Math.round(val.end * 100) / 100}</td>
                                <td>
                                    {editMode.includes(i) ?
                                        <textarea
                                            style={{ width: "100%" }}
                                            disabled={saving.includes(i)}
                                            value={val.text}
                                            onChange={(e) => {
                                                setLocalData((prev) => {
                                                    const newData = [...prev]
                                                    newData[i] = {
                                                        ...newData[i],
                                                        text: e.target.value,
                                                    }
                                                    return newData;
                                                })
                                            }}
                                        />
                                        : val.text}
                                </td>
                                <td>
                                    <img
                                        style={{ cursor: 'pointer' }}
                                        src={"/images/play-circle.svg"}
                                        alt="play"
                                        onClick={(event) => {
                                            if (!editMode.length) {
                                                scrollRef.current.scrollIntoView();
                                                onPlayClick(Math.round(val.start * 100) / 100, Math.round(val.end * 100) / 100)
                                            } else {
                                                setVideoPopoverTarget(event.target);
                                                setVideoPopoverTranscriptData(val);
                                            }
                                        }}
                                    />
                                </td>
                                {(isAdmin || hasEdit) &&
                                <td>
                                    {!editMode.includes(i) ?
                                        <img
                                            style={{ cursor: 'pointer' }}
                                            src={"/images/edit.svg"}
                                            alt="edit"
                                            onClick={() => setEditMode((prev) => [...prev, i])}
                                        /> :
                                        <img
                                            style={{ cursor: 'pointer' }}
                                            src={"/images/save.svg"}
                                            alt="save"
                                            onClick={() => saving.includes(i) ? {} : saveTranscriptMutation({ val, i })}
                                        />
                                    }
                                </td>
                                }
                                {(isAdmin || hasEdit) &&
                                <td>
                                    <img
                                        style={{ cursor: 'pointer' }}
                                        src={"/images/delete-grey.svg"}
                                        alt="trash"
                                        onClick={() => setDeleteItem(val)}
                                    />
                                </td>
            }   
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            {deleteItem !== null &&
                <DeleteConfirmationModal
                    loading={isDeletingTranscript}
                    onClose={() => setDeleteItem(null)}
                    onConfirm={() => deleteTranscriptMutation({val: deleteItem})}
                />
            }
            {showAddTranscript &&
                <AddTranscriptModal
                    videoCode={videoCode}
                    onClose={() => {
                        setShowAddTranscript(false);
                    }}
                    onSave={refreshTranscript}
                    enableChapterRegeneration={enableChapterRegeneration}
                />
            }
        </>
    );
};

export default TranscriptTable;
